import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function usePageTracker(user, selectedCity) {
  const location = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    const key = location.pathname;
    if (key === lastTracked.current) return;
    lastTracked.current = key;

    const track = async () => {
      try {
        await axios.post(`${API}/track/hit`, {
          page: location.pathname,
          referrer: document.referrer || '',
          user_id: user?.user_id || null,
          city: selectedCity || '',
        });
      } catch { /* silent */ }
    };
    track();
  }, [location.pathname, user?.user_id, selectedCity]);
}
